import { TFunction } from 'react-i18next';
import { CardStatuses } from '../types';
import { CardFilterStatuses } from '../types';

export enum Color {
  default = 'default',
  success = 'success',
  info = 'info',
  error = 'error',
  warning = 'warning',
}

const mappingCardStatuses = (t: TFunction) => ({
  [CardStatuses.Active]: {
    filterStatus: {
      value: CardFilterStatuses.ACTIVE,
      label: t('cardFilterStatuses.Labels.Active'),
    },
    statusChip: {
      value: t('CardStatus.Active'),
      color: 'success' as Color,
    },
  },
  [CardStatuses.Inactive]: {
    filterStatus: {
      value: CardFilterStatuses.INACTIVE,
      label: t('cardFilterStatuses.Labels.Pending'),
    },
    statusChip: {
      value: t('CardStatus.Pending'),
      color: 'warning' as Color,
    },
  },
  [CardStatuses.In_Progress]: {
    filterStatus: {
      value: CardFilterStatuses.IN_PROGRESS,
      label: t('cardFilterStatuses.Labels.Pending'),
    },
    statusChip: {
      value: t('CardStatus.Pending'),
      color: 'warning' as Color,
    },
  },
  [CardStatuses.Blocked]: {
    filterStatus: {
      value: CardFilterStatuses.BLOCKED,
      label: t('cardFilterStatuses.Labels.Frozen'),
    },
    statusChip: {
      value: t('CardStatus.Frozen'),
      color: 'default' as Color,
    },
  },
  [CardStatuses.Lost]: {
    filterStatus: {
      value: CardFilterStatuses.LOST,
      label: t('cardFilterStatuses.Labels.LOST'),
    },
    statusChip: {
      value: t('CardStatus.LOST'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Stolen]: {
    filterStatus: {
      value: CardFilterStatuses.STOLEN,
      label: t('cardFilterStatuses.Labels.STOLEN'),
    },
    statusChip: {
      value: t('CardStatus.STOLEN'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Fraud]: {
    filterStatus: {
      value: CardFilterStatuses.FRAUD,
      label: t('cardFilterStatuses.Labels.Terminated'),
    },
    statusChip: {
      value: t('CardStatus.Terminated'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Not_Received]: {
    filterStatus: {
      value: CardFilterStatuses.NOT_RECEIVED,
      label: t('cardFilterStatuses.Labels.NOT_RECEIVED'),
    },
    statusChip: {
      value: t('CardStatus.NOT_RECEIVED'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Damaged]: {
    filterStatus: {
      value: CardFilterStatuses.DAMAGED,
      label: t('cardFilterStatuses.Labels.DAMAGED'),
    },
    statusChip: {
      value: t('CardStatus.DAMAGED'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Closed]: {
    filterStatus: {
      value: CardFilterStatuses.CLOSED,
      label: t('cardFilterStatuses.Labels.Terminated'),
    },
    statusChip: {
      value: t('CardStatus.Terminated'),
      color: 'error' as Color,
    },
  },
  [CardStatuses.Pin_Tries_Exceeded]: {
    filterStatus: {
      value: CardFilterStatuses.PIN_TRIES_EXCEEDED,
      label: t('cardFilterStatuses.Labels.PinTriesExceeded'),
    },
    statusChip: {
      value: t('CardStatus.PinTriesExceeded'),
      color: 'error' as Color,
    },
  },
});

export { mappingCardStatuses };
